import { styled } from '@mui/material';
import { m } from 'framer-motion';
export const ControlButton = styled(m.div)({
    borderRadius: 8,
    height: '100%',
    boxShadow: 'none',
    fontSize: 'inherit',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    padding: '8px',
    userSelect: 'none',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    ':focus': {
        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.6)',
    },
});
